export default "__VITE_ASSET__D$euXatH__"